
<p *ngIf="getType('privacy')" class="policy-text">{{label}}</p>
<mat-checkbox *ngIf="getType('privacy')" class="example-margin" [(ngModel)]="checked" [(indeterminate)]="indeterminate" [labelPosition]="labelPosition" (change)="onPrivacyChecked()">
    He leído y acepto la <a href="{{url}}" target="_blank">Política de Privacidad</a>.
</mat-checkbox>

<mat-checkbox *ngIf="getType('terms')" class="example-margin" [(ngModel)]="checked" [(indeterminate)]="indeterminate" [labelPosition]="labelPosition" (change)="onPrivacyChecked()">
    He leído y acepto los <a href="{{url}}" target="_blank">Términos y Condiciones de Servicio</a> de VoyJaleas.
</mat-checkbox>